import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimes, faChevronDown, faSearch } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CreateFlyerDto } from 'projects/clooper/core/src/public-api';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { AIRLINES, Airline } from '../data/airlines.data';
import { FlyerService } from '@clooper/core';
import { flyerNumberValidator } from '../../shared/validators/id-document.validators';

@Component({
  selector: 'app-add-flyer-info-modal',
  templateUrl: './add-flyer-info-modal.component.html',
  styleUrls: ['./add-flyer-info-modal.component.scss']
})
export class AddFlyerInfoModalComponent implements OnInit {
  icons = { close: faTimes, chevronDown: faChevronDown, search: faSearch };
  flyerForm: FormGroup;

  airlines: Airline[] = AIRLINES;
  filteredAirlines: Airline[] = AIRLINES;
  airlineSearch = '';
  showAirlineDropdown = false;
  selectedAirline: Airline | null = null;
  isSubmitting = false;
  duplicateAirlineError = false;
  existingAirlineCodes: string[] = [];
  onAdded?: () => void;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private elRef: ElementRef,
    private flyerService: FlyerService
  ) {}

  ngOnInit(): void {
    this.flyerForm = this.fb.group({
      flyer_id: ['', [Validators.required, flyerNumberValidator]],
      airline: ['', Validators.required],
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elRef.nativeElement.querySelector('.airline-dropdown-wrapper')?.contains(event.target)) {
      this.showAirlineDropdown = false;
    }
  }

  toggleDropdown(): void {
    this.showAirlineDropdown = !this.showAirlineDropdown;
    if (this.showAirlineDropdown) {
      this.airlineSearch = '';
      this.filteredAirlines = this.airlines;
    }
  }

  filterAirlines(): void {
    const term = this.airlineSearch.toLowerCase();
    this.filteredAirlines = this.airlines.filter(
      a => a.name.toLowerCase().includes(term) || a.iata_code.toLowerCase().includes(term)
    );
  }

  selectAirline(airline: Airline): void {
    this.selectedAirline = airline;
    this.flyerForm.get('airline')?.setValue(airline.name);
    this.showAirlineDropdown = false;
    this.duplicateAirlineError = this.existingAirlineCodes.includes(airline.iata_code);
  }

  close(): void {
    this.bsModalRef?.hide();
  }

  add(): void {
    if (this.flyerForm.valid && !this.isSubmitting && !this.duplicateAirlineError) {
      this.isSubmitting = true;
      const payload: CreateFlyerDto = {
        flyer_number: this.flyerForm.value.flyer_id,
        airline: this.selectedAirline?.iata_code || this.flyerForm.value.airline,
        airline_name: this.selectedAirline?.name || this.flyerForm.value.airline
      };
      this.flyerService.createFlyerFullResponse(payload).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.onAdded?.();
          this.close();
          this.modalService.show(SuccessModalComponent, {
            initialState: {
              title: 'Flyer Info Added!',
              subtitle: 'Your frequent flyer information has been added successfully.'
            },
            class: 'modal-rounded'
          });
        },
        error: () => {
          this.isSubmitting = false;
        }
      });
    }
  }
}
